<a class="language-wrapper" (click)="languageHandle()">
  <div
    [ngStyle]="{
      transform: 'translateX(' + -25 * selectedLanguageIndex + 'px)'
    }"
  >
    <mat-icon
      *ngFor="let item of langFlag"
      [svgIcon]="'flag' + item"
    ></mat-icon>
    <!-- <img
      *ngFor="let item of langFlag"
      src="{{ 'assets/images/flag-' + item + '.svg' | lowercase }}"
    /> -->
  </div>
</a>
